import { LoadState } from "../../constants/enums";
import { IReceiptReport, IReceiptReportState } from "./recieptypes";





export const defaultReceiptReport: IReceiptReport = {
    fee_transaction_id: 0,
    fee_transaction_unique_id: 0,
    fee_transaction_uuid: "",
    opportunity_uuid: "",
    customer_fact_uuid: "",
    customer_name: "",
    customer_code: "",
    organizations_uuid: "",
    organizations_name: "",
    batch: "",
    courses_uuid: "",
    courses_name: "",
    academic_year: "",
    fees_paid: "",
    fee_type: "",
    payment_mode: "",
    remarks: "",
    created_by_uuid: "",
    created_by_name: "",
    modified_by_uuid: "",
    modified_by_name: "",
    create_ts: "",
    insert_ts: "",
}

export const defaultReceiptReportState: IReceiptReportState = {
    list: {
        data: [],
        loading: LoadState.NotLoaded,
        totalRecords: 0,
        error: null,
    },
    recieptReport: {
        data: defaultReceiptReport,
        loading: LoadState.NotLoaded,
        totalRecords: 0,
        error: null,
    },
    amount: {
        totalPaidFee: 0,
    }
}